import { render, staticRenderFns } from "./PromotionsNeopag.vue?vue&type=template&id=1014747a&"
import script from "./PromotionsNeopag.vue?vue&type=script&lang=js&"
export * from "./PromotionsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports